// store/slices/dashboardSlice.ts

import { Card as NewCardType } from "@/app/(dashboard)/dashboard/test-dashboard/components/types";
import { DashboardCard } from "../types/store";

export interface NewDashboardData {
  name: string;
  cards: NewCardType[];
  dashboardId: string;
  type?: "template" | "shared";
  invitedBy?: string;
}
export interface DashboardState {
  dashboardData: NewDashboardData[];
  selectedDashboard: string | null;
}

export interface DashboardActions {
  setSelectedDashboard: (id: string | null) => void;
  setDashboardData: (dashboardData: NewDashboardData[]) => void;
  // updateDashboardCard: ({
  //   dashboardName,
  //   cardIndex,
  //   newCardData,
  // }: {
  //   dashboardName: string;
  //   cardIndex: number;
  //   newCardData: Partial<DashboardCard>;
  // }) => void;
  // addDashboardCard: (dashboardID: string, newCard: DashboardCard) => void;
  updateCardType: ({
    dashboardId,
    cardId,
    newCardType,
  }: {
    dashboardId: string;
    cardId: string;
    newCardType: string;
  }) => void;
  updateCardDefaultTimeRange: ({
    dashboardId,
    cardId,
    newDefaultTimeRange,
  }: {
    dashboardId: string;
    cardId: string;
    newDefaultTimeRange: number;
  }) => void;
  removeDashboardCard: (dashboardName: string, cardIndex: number) => void;
  setDashboardCards: (dashboardName: string, newCards: DashboardCard[]) => void;
  addDashboard: (dashboardName: string) => string;
  updateDashboardName: (dashboardId: string, newName: string) => void;
  deleteDashboard: (dashboardId: string) => void;
  duplicateDashboard: (dashboardId: string) => string;
  reorderDashboards: (newDashboardsOrder: NewDashboardData[]) => void;
}

export const dashboardSlice = (
  set: any,
): { data: DashboardState; actions: DashboardActions } => ({
  data: {
    dashboardData: [],
    selectedDashboard: "",
  },
  actions: {
    setSelectedDashboard: (id: string | null) => {
      set((state: any) => {
        state.data.selectedDashboard = id;
      });
    },
    setDashboardData: (dashboardData: NewDashboardData[]) => {
      set((state: any) => {
        state.data.dashboardData = dashboardData;
      });
    },
    updateCardType: ({ dashboardId, cardId, newCardType }) => {
      // alert("cardId : " + cardId + " : " + dashboardId + " : " + newCardType);
      set((state: any) => {
        const dashboard = state.data.dashboardData.find(
          (dashboard: NewDashboardData) =>
            dashboard.dashboardId === dashboardId,
        );

        if (dashboard) {
          const cardToUpdate = dashboard.cards.find(
            (card: any) => card.id === cardId,
          );
          console.log(cardToUpdate);
          if (cardToUpdate) {
            cardToUpdate.cardType = newCardType;
          }
        }
      });
    },

    updateCardDefaultTimeRange: ({
      dashboardId,
      cardId,
      newDefaultTimeRange,
    }) => {
      set((state: any) => {
        const dashboard = state.data.dashboardData.find(
          (dashboard: NewDashboardData) =>
            dashboard.dashboardId === dashboardId,
        );

        if (dashboard) {
          const cardToUpdate = dashboard.cards.find(
            (card: any) => card.id === cardId,
          );
          if (cardToUpdate) {
            cardToUpdate.defaultTimeRange = newDefaultTimeRange;
          }
        }
      });
    },

    removeDashboardCard: (dashboardName, cardIndex) => {
      set((state: any) => {
        const dashboard: any = state.data.dashboardData[dashboardName];
        if (dashboard) {
          dashboard.cards = dashboard.cards.filter(
            (card: any) => card.index !== cardIndex,
          );
        }
      });
    },
    setDashboardCards: (dashboardId: string, newCards: any) => {
      set((state: any) => {
        const dashboardIndex = state.data.dashboardData.findIndex(
          (dashboard: NewDashboardData) =>
            dashboard.dashboardId === dashboardId,
        );

        if (dashboardIndex !== -1) {
          state.data.dashboardData[dashboardIndex].cards = newCards;
        }
      });
    },
    addDashboard: (dashboardName: string) => {
      const id = crypto.randomUUID();
      set((state: any) => {
        state.data.dashboardData.push({
          dashboardId: id,
          name: dashboardName,
          cards: [],
        });
        state.data.selectedDashboard = id;
      });
      return id;
    },
    updateDashboardName: (dashboardId: string, newName: string) => {
      set((state: any) => {
        const dashboardIndex = state.data.dashboardData.findIndex(
          (dashboard: NewDashboardData) =>
            dashboard.dashboardId === dashboardId,
        );

        if (dashboardIndex !== -1) {
          state.data.dashboardData[dashboardIndex].name = newName;
        }
      });
    },

    deleteDashboard: (dashboardId: string) => {
      set((state: any) => {
        state.data.dashboardData = state.data.dashboardData.filter(
          (dashboard: NewDashboardData) =>
            dashboard.dashboardId !== dashboardId,
        );

        if (state.data.selectedDashboard === dashboardId) {
          state.data.selectedDashboard =
            state.data.dashboardData.length > 0
              ? state.data.dashboardData[0].dashboardId
              : null;
        }
      });
    },

    duplicateDashboard: (dashboardId: string) => {
      const newId = crypto.randomUUID();
      let duplicatedDashboard: NewDashboardData | null = null;

      set((state: any) => {
        const originalDashboard = state.data.dashboardData.find(
          (dashboard: NewDashboardData) =>
            dashboard.dashboardId === dashboardId,
        );

        if (originalDashboard) {
          // Find the next available copy number
          const baseName = originalDashboard.name;
          const existingNames = state.data.dashboardData.map(
            (d: NewDashboardData) => d.name,
          );

          // Check if the base name already has a copy suffix
          const copyRegex = /^(.*) \(Copy(?: (\d+))?\)$/;
          const baseNameMatch = baseName.match(copyRegex);
          const actualBaseName = baseNameMatch ? baseNameMatch[1] : baseName;

          let copyNumber = 1;
          let newName = `${actualBaseName} (Copy ${copyNumber})`;

          // Find the next available copy number
          while (existingNames.includes(newName)) {
            copyNumber++;
            newName = `${actualBaseName} (Copy ${copyNumber})`;
          }

          // Create a deep copy of the original dashboard
          duplicatedDashboard = {
            ...originalDashboard,
            dashboardId: newId,
            name: newName,
            cards: originalDashboard.cards.map((card: any) => ({
              ...card,
              id: crypto.randomUUID(), // Generate new IDs for cards to avoid conflicts
            })),
          };

          // Add the duplicated dashboard to the array
          state.data.dashboardData.push(duplicatedDashboard);

          // Set the duplicated dashboard as selected
          state.data.selectedDashboard = newId;
        }
      });

      return newId;
    },

    reorderDashboards: (newDashboardsOrder: NewDashboardData[]) => {
      set((state: any) => {
        state.data.dashboardData = newDashboardsOrder;
      });
    },
  },
});
